import { useQuery } from '@tanstack/react-query';
import { throwUnlessDefined } from 'utils/functional/functionalUtils';

const REACT_APP_DETECTOR_BASE_API_URL = throwUnlessDefined(process.env.REACT_APP_DETECTOR_BASE_API_URL);
const eventTagResendStatUrl = `${REACT_APP_DETECTOR_BASE_API_URL}event_tag_resend_stat`;

export interface DetectorEntry {
  name: string;
  status: string;
  tags: number[];
}

export interface EventTagResendStat {
  detectors: DetectorEntry[];
  tagId: string;
  tagIdDecimal: string;
  fromDate: string;
  toDate: string;
  detections: number;
  resends: number;
  avgRssi: number;
  avgResendCounter: number;
  maxResendCounter: number;
  minResendCounter: number;
  problemScore: number;
}

export interface EventTagResendStatResponse {
  results: EventTagResendStat[];
}

const fetchEventTagResendStat = async (): Promise<EventTagResendStat[]> => {
  const response = await fetch(eventTagResendStatUrl, {
    method: 'GET',
    headers: {
      accept: 'application/json',
    },
  });

  if (!response.ok) {
    throw new Error(`Network response was not ok: ${response.statusText}`);
  }

  const json: EventTagResendStatResponse = await response.json();
  return json.results;
};

const useFetchEventTagResendStat = (shouldFetch: boolean = true) => {
  const { data, isLoading, error } = useQuery<EventTagResendStat[]>({
    queryKey: ['fetchEventTagResendStat'],
    queryFn: fetchEventTagResendStat,
    enabled: shouldFetch,
  });

  return {
    data,
    isLoading,
    error,
  };
};

export default useFetchEventTagResendStat;
